import { ReactNode, useState } from 'react';
import { FrStateContext } from './fr-state-context';

export function FrStateProvider({ children }: { children: ReactNode }) {
    const [wasHeldEventsModalShown, setWasHeldEventsModalShown] = useState<boolean>(false);

    return (
        <FrStateContext.Provider
            value={{
                wasHeldEventsModalShown,
                setWasHeldEventsModalShown,
            }}
        >
            {children}
        </FrStateContext.Provider>
    );
}
